import React from 'react';
import { Collapse, Row, Col } from 'antd';
import bodyWorkAccept from '../../assets/images/fairware&tear/body-work-accept.png';
import bodyWorkUnAccept from '../../assets/images/fairware&tear/body-work-unaccept.png';

import bumperAccept from '../../assets/images/fairware&tear/bumper-accept.png';
import bumperUnAccept from '../../assets/images/fairware&tear/bumper-unaccept.png';

import decalAccept from '../../assets/images/fairware&tear/decal-accept.png';
import decalUnAccept from '../../assets/images/fairware&tear/decal-unaccept.png';

import glassAccept from '../../assets/images/fairware&tear/glass-accept.png';
import glassUnAccept from '../../assets/images/fairware&tear/glass-unaccept.png';

import interiorAccept from '../../assets/images/fairware&tear/interior-accept.png';
import interiorUnAccept from '../../assets/images/fairware&tear/interior-unaccept.png';

import unauthoriseRepair1 from '../../assets/images/fairware&tear/unauthorise-repair1.png';
import unauthoriseRepair2 from '../../assets/images/fairware&tear/unauthorise-repair2.png';
import unauthoriseRepair3 from '../../assets/images/fairware&tear/unauthorise-repair3.png';

import wheelAccept from '../../assets/images/fairware&tear/wheel-accept.png';
import wheelUnAccept from '../../assets/images/fairware&tear/wheel-unaccept.png';

import windMirrorAccept from '../../assets/images/fairware&tear/wind-mirror-accept.png';
import windMirrorUnAccept from '../../assets/images/fairware&tear/wind-mirror-unaccept.png';

import SEO from '../../components/SEO';

const { Panel } = Collapse;

const FairwareAndTearPolicy = () => {
    function callback(key) {}

    return (
        <div className="fairwareAndTearPolicyContainer">
            <SEO
                title="Fair Ware & Tear"
                description="One-Stop Transport & Finicial Solution"
                path="fare-ware-and-tear"
            />
            <Row justify="center" className="fairwareAndTearPolicyInfo">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                >
                    <h2 className="sectionTitle">Fair Wear and Tear Policy</h2>
                </Col>

                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                >
                    <p className="paragraph">
                        We believe Wear and Tear is a natural occurrence with everyday usage causing acceptable
                        deterioration to any vehicle. However, this is not to be confused with Damage, resulting from a
                        specific event such as impact, inappropriately stowing items, harsh treatment or negligent acts.
                        During check-in and check-out it is the responsibility of the driver and owner of the vehicle to
                        inspect and identify any pre-existing damage on the vehicle. Clear communication during this
                        process will ensure a smooth ride for both parties, what constitutes damage? Anything smaller
                        than 50mm is not classified as damage therefore will not be noted on the check-in sheet.
                    </p>
                </Col>

                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="fairwareAndTearPolicySamples"
                >
                    <h4 className="blockTitle text-center">Let’s look at a few examples</h4>
                </Col>

                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                >
                    <h4 className="fairwareAndTearPolicySubTitleAccept">Acceptable</h4>
                    <p className="paragraph text-center">
                        For scratches on body panels minor scuffing up to 25mm in length.{' '}
                    </p>
                </Col>

                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                >
                    <h4 className="fairwareAndTearPolicySubTitleUnccept">Unacceptable</h4>
                    <p className="paragraph text-center">
                        For tires cuts, bulges and damage to side walls or uneven tread wear.{' '}
                    </p>
                </Col>
            </Row>

            <Row justify="center" className="fairwareAndTearPolicyList">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 20 }}
                    lg={{ span: 20 }}
                    xl={{ span: 20 }}
                    xxl={{ span: 20 }}
                >
                    {/* <span className="fairwareAndTearDesc">Here are few common info:</span> */}

                    <Collapse onChange={callback}>
                        <Panel header="WHEEL" key="1">
                            <Row>
                                <Col
                                    xs={{ span: 24 }}
                                    sm={{ span: 24 }}
                                    md={{ span: 24 }}
                                    lg={{ span: 10 }}
                                    xl={{ span: 10 }}
                                    xxl={{ span: 10 }}
                                    className="fairwareAndTearPolicyListLeft"
                                >
                                    <h4 className="fairwareAndTearPolicySubTitleAccept">Acceptable</h4>
                                    <p className="paragraph">
                                        Minor scuffing as long as no paintwork is damaged. <br />
                                        (i.e. Scuffing not through the paintwork.) <br />
                                        Scratches that can be polished out.
                                    </p>
                                    <img
                                        className="fairwareAndTearPolicySubImage"
                                        src={wheelAccept}
                                        alt="Body Work Accept"
                                    />
                                </Col>
                                <Col
                                    xs={{ span: 24 }}
                                    sm={{ span: 24 }}
                                    md={{ span: 24 }}
                                    lg={{ span: 10, offset: 2 }}
                                    xl={{ span: 10, offset: 2 }}
                                    xxl={{ span: 10, offset: 2 }}
                                >
                                    <h4 className="fairwareAndTearPolicySubTitleUnccept">Unacceptable</h4>
                                    <p className="paragraph">
                                        Missing, Damaged or Cracked Wing Mirrors.
                                        <br />
                                        Scratches affecting the vehicle’s appearance. <br />
                                        (i.e. Scratches through the paintwork.)
                                    </p>
                                    <img
                                        className="fairwareAndTearPolicySubImage"
                                        src={wheelUnAccept}
                                        alt="Body Work Unaccept"
                                    />
                                </Col>
                            </Row>
                        </Panel>
                        <Panel header="WING MIRRORS" key="2">
                            <Row>
                                <Col
                                    xs={{ span: 24 }}
                                    sm={{ span: 24 }}
                                    md={{ span: 24 }}
                                    lg={{ span: 10 }}
                                    xl={{ span: 10 }}
                                    xxl={{ span: 10 }}
                                    className="fairwareAndTearPolicyListLeft"
                                >
                                    <h4 className="fairwareAndTearPolicySubTitleAccept">Acceptable</h4>
                                    <p className="paragraph">
                                        Minor scuffing no larger than 50mm to non-painted parts from loading/ unloading.
                                    </p>
                                    <img
                                        className="fairwareAndTearPolicySubImage"
                                        src={windMirrorAccept}
                                        alt="WING MIRRORS Accept"
                                    />
                                </Col>
                                <Col
                                    xs={{ span: 24 }}
                                    sm={{ span: 24 }}
                                    md={{ span: 24 }}
                                    lg={{ span: 10, offset: 2 }}
                                    xl={{ span: 10, offset: 2 }}
                                    xxl={{ span: 10, offset: 2 }}
                                >
                                    <h4 className="fairwareAndTearPolicySubTitleUnccept">Unacceptable</h4>
                                    <p className="paragraph">
                                        Deep scuffs, gouges, cuts/ cracks where the pane is broken, dented, and any
                                        cracks causing distortion to the vehicle's appearance.
                                    </p>
                                    <img
                                        className="fairwareAndTearPolicySubImage"
                                        src={windMirrorUnAccept}
                                        alt="WING MIRRORS Unaccept"
                                    />
                                </Col>
                            </Row>
                        </Panel>
                        <Panel header="BUMPERS" key="3">
                            <Row>
                                <Col
                                    xs={{ span: 24 }}
                                    sm={{ span: 24 }}
                                    md={{ span: 24 }}
                                    lg={{ span: 10 }}
                                    xl={{ span: 10 }}
                                    xxl={{ span: 10 }}
                                    className="fairwareAndTearPolicyListLeft"
                                >
                                    <h4 className="fairwareAndTearPolicySubTitleAccept">Acceptable</h4>
                                    <p className="paragraph">
                                        Minor scuffing no larger than 50mm to non-painted parts from loading/ unloading.
                                    </p>
                                    <img
                                        className="fairwareAndTearPolicySubImage"
                                        src={bumperAccept}
                                        alt="BUMPERS Accept"
                                    />
                                </Col>
                                <Col
                                    xs={{ span: 24 }}
                                    sm={{ span: 24 }}
                                    md={{ span: 24 }}
                                    lg={{ span: 10, offset: 2 }}
                                    xl={{ span: 10, offset: 2 }}
                                    xxl={{ span: 10, offset: 2 }}
                                >
                                    <h4 className="fairwareAndTearPolicySubTitleUnccept">Unacceptable</h4>
                                    <p className="paragraph">
                                        Deep scuffs, gouges, cuts/ cracks where the pane is broken, dented, and any
                                        cracks causing distortion to the vehicle's appearance.
                                    </p>
                                    <img
                                        className="fairwareAndTearPolicySubImage"
                                        src={bumperUnAccept}
                                        alt="BUMPERS Unaccept"
                                    />
                                </Col>
                            </Row>
                        </Panel>
                        <Panel header="BODYWORK" key="4">
                            <Row>
                                <Col
                                    xs={{ span: 24 }}
                                    sm={{ span: 24 }}
                                    md={{ span: 24 }}
                                    lg={{ span: 10 }}
                                    xl={{ span: 10 }}
                                    xxl={{ span: 10 }}
                                    className="fairwareAndTearPolicyListLeft"
                                >
                                    <h4 className="fairwareAndTearPolicySubTitleAccept">Acceptable</h4>
                                    <p className="paragraph">
                                        Stone chips will be allowable on forward-facing panels, which are consistent
                                        with the age and mileage of the vehicle, light scratches of up to 25mm in length
                                        - relative to vehicle's age; dents up to 10mm providing paint is not broken,
                                        scratches that can be polished out.{' '}
                                    </p>
                                    <img
                                        className="fairwareAndTearPolicySubImage"
                                        src={bodyWorkAccept}
                                        alt="BODYWORK Accept"
                                    />
                                </Col>
                                <Col
                                    xs={{ span: 24 }}
                                    sm={{ span: 24 }}
                                    md={{ span: 24 }}
                                    lg={{ span: 10, offset: 2 }}
                                    xl={{ span: 10, offset: 2 }}
                                    xxl={{ span: 10, offset: 2 }}
                                >
                                    <h4 className="fairwareAndTearPolicySubTitleUnccept">Unacceptable</h4>
                                    <p className="paragraph">
                                        Stone chips or scratches over 2 inches in length which have exposed the bare
                                        metal of the vehicle, any impact damage, multiple dents on a single panel.
                                    </p>
                                    <img
                                        className="fairwareAndTearPolicySubImage"
                                        src={bodyWorkUnAccept}
                                        alt="BODYWORK Unaccept"
                                    />
                                </Col>
                            </Row>
                        </Panel>
                        <Panel header="DECALS" key="5">
                            <Row>
                                <Col
                                    xs={{ span: 24 }}
                                    sm={{ span: 24 }}
                                    md={{ span: 24 }}
                                    lg={{ span: 10 }}
                                    xl={{ span: 10 }}
                                    xxl={{ span: 10 }}
                                    className="fairwareAndTearPolicyListLeft"
                                >
                                    <h4 className="fairwareAndTearPolicySubTitleAccept">Acceptable</h4>
                                    <p className="paragraph">
                                        All decals need to be removed along with all glue residue.{' '}
                                    </p>
                                    <img
                                        className="fairwareAndTearPolicySubImage"
                                        src={decalAccept}
                                        alt="DECALS Accept"
                                    />
                                </Col>
                                <Col
                                    xs={{ span: 24 }}
                                    sm={{ span: 24 }}
                                    md={{ span: 24 }}
                                    lg={{ span: 10, offset: 2 }}
                                    xl={{ span: 10, offset: 2 }}
                                    xxl={{ span: 10, offset: 2 }}
                                >
                                    <h4 className="fairwareAndTearPolicySubTitleUnccept">Unacceptable</h4>
                                    <p className="paragraph">
                                        Any damage to the paintwork caused by the removal of any badges or advertising.
                                    </p>
                                    <img
                                        className="fairwareAndTearPolicySubImage"
                                        src={decalUnAccept}
                                        alt="DECALS Unaccept"
                                    />
                                </Col>
                            </Row>
                        </Panel>
                        <Panel header="INTERIOR UPHOLSTERS" key="6">
                            <Row>
                                <Col
                                    xs={{ span: 24 }}
                                    sm={{ span: 24 }}
                                    md={{ span: 24 }}
                                    lg={{ span: 10 }}
                                    xl={{ span: 10 }}
                                    xxl={{ span: 10 }}
                                    className="fairwareAndTearPolicyListLeft"
                                >
                                    <h4 className="fairwareAndTearPolicySubTitleAccept">Acceptable</h4>
                                    <p className="paragraph">
                                        Needs to be clean and tidy, with only slight wear through normal use. Seat
                                        cover/ trim repairs of a high standard.{' '}
                                    </p>
                                    <img
                                        className="fairwareAndTearPolicySubImage"
                                        src={interiorAccept}
                                        alt="INTERIOR UPHOLSTERS Accept"
                                    />
                                </Col>
                                <Col
                                    xs={{ span: 24 }}
                                    sm={{ span: 24 }}
                                    md={{ span: 24 }}
                                    lg={{ span: 10, offset: 2 }}
                                    xl={{ span: 10, offset: 2 }}
                                    xxl={{ span: 10, offset: 2 }}
                                >
                                    <h4 className="fairwareAndTearPolicySubTitleUnccept">Unacceptable</h4>
                                    <p className="paragraph">
                                        Burns, tears or permanent staining; any damage caused by the fitting of
                                        equipment such as mobile phones, satnav, missing floor mats.
                                    </p>
                                    <img
                                        className="fairwareAndTearPolicySubImage"
                                        src={interiorUnAccept}
                                        alt="INTERIOR UPHOLSTERS Unaccept"
                                    />
                                </Col>
                            </Row>
                        </Panel>
                        <Panel header="GLASS DAMAGE" key="7">
                            <Row>
                                <Col
                                    xs={{ span: 24 }}
                                    sm={{ span: 24 }}
                                    md={{ span: 24 }}
                                    lg={{ span: 10 }}
                                    xl={{ span: 10 }}
                                    xxl={{ span: 10 }}
                                    className="fairwareAndTearPolicyListLeft"
                                >
                                    <h4 className="fairwareAndTearPolicySubTitleAccept">Acceptable</h4>
                                    <p className="paragraph">
                                        Needs to be clean and tidy, with only slight wear through normal use. Seat
                                        cover/ trim repairs of a high standard.{' '}
                                    </p>
                                    <img
                                        className="fairwareAndTearPolicySubImage"
                                        src={glassAccept}
                                        alt="BODYWORK Accept"
                                    />
                                </Col>
                                <Col
                                    xs={{ span: 24 }}
                                    sm={{ span: 24 }}
                                    md={{ span: 24 }}
                                    lg={{ span: 10, offset: 2 }}
                                    xl={{ span: 10, offset: 2 }}
                                    xxl={{ span: 10, offset: 2 }}
                                >
                                    <h4 className="fairwareAndTearPolicySubTitleUnccept">Unacceptable</h4>
                                    <p className="paragraph">
                                        Burns, tears or permanent staining; any damage caused by the fitting of
                                        equipment such as mobile phones, satnav, missing floor mats.
                                    </p>
                                    <img
                                        className="fairwareAndTearPolicySubImage"
                                        src={glassUnAccept}
                                        alt="BODYWORK Unaccept"
                                    />
                                </Col>
                            </Row>
                        </Panel>
                        <Panel header="UNAUTHORIZED REPAIR" key="8">
                            <ul>
                                <li>
                                    If you have caused any damage to the vehicle you are required to contact Yoma Fleet
                                    to have it repaired to its original state.
                                </li>
                                <li>
                                    In the event that you have these repairs completed independently, and they are of an
                                    inferior standard, you are liable to pay for further repairs needed to restore the
                                    original state, and you will be billed the full cost.
                                </li>
                                <li>Every repair has to be approved by the vehicle owner. </li>
                                <li>
                                    Examples of non-professional repairs are:
                                    <ul>
                                        <li>Previous body repairs and paint corrections that are easily visible</li>
                                        <li>
                                            Poor color matching, ripples, preparation marks, visible overspray, masking
                                            lines or excessive dirt in the paint.{' '}
                                        </li>
                                        <li>Uneven post-repair surface</li>
                                    </ul>
                                </li>
                            </ul>
                            <img
                                className="fairwareAndTearPolicySubUnauthoImage"
                                src={unauthoriseRepair1}
                                alt="Unauthorise Repair"
                            />
                            <img
                                className="fairwareAndTearPolicySubUnauthoImage"
                                src={unauthoriseRepair2}
                                alt="Unauthorise Repair"
                            />
                            <img
                                className="fairwareAndTearPolicySubUnauthoImage"
                                src={unauthoriseRepair3}
                                alt="Unauthorise Repair"
                            />
                        </Panel>
                        <Panel header="VEHICLE DELIVERY PROCEDURE" key="9">
                            <h5>Once the booking has been processed and the lease approved: </h5>
                            <ul>
                                <li>We will deliver your vehicle.</li>
                                <li>
                                    Inspect the car thoroughly in good lighting to reveal any current wear and tear, and
                                    communicate this to our delivery staff, ensuring both parties are aware of and
                                    scuffs and scratches which are them to be documented on the delivery receipt
                                    document if very minor. In the event of significant damage, the vehicle will be
                                    withdrawn for rectification.
                                </li>
                                <li>
                                    If you feel the car is not fit for the road or you are unhappy with the condition,
                                    please let us know and we will rectify the issue or offer you an alternative
                                    vehicle.
                                </li>
                                <li>
                                    The vehicle will be delivered with a full tank of fuel, a small medical first aid
                                    kit and a small fire extinguisher.
                                </li>
                            </ul>
                        </Panel>
                        <Panel header="VEHICLE RETURN PROCEDURE" key="104">
                            <p>
                                Please ensure the vehicle is made ready for return clean, safe and with a full fuel tank
                                (or recharges will apply).{' '}
                            </p>
                            <p>
                                It is much easier to appraise the vehicle once it has been cleaned to allow a thorough
                                inspection of the vehicle.{' '}
                            </p>
                            <p className="paragraphNotice">
                                A few hints and tips for completing a successful vehicle return that will help to
                                identify any damage that does not constitute as fair wear and tear that will require
                                repair.
                            </p>
                            <ul>
                                <li>
                                    Carry out an appraisal of the vehicle 2-3 weeks before you are due to return it.
                                    This will allow you enough time to arrange with Yoma Fleet to have any unacceptable
                                    wear and tear sorted out.{' '}
                                </li>
                                <li>
                                    Appraise the vehicle as honestly as you can and be objective, try getting a second
                                    opinion from a friend.{' '}
                                </li>
                                <li>
                                    Choose a time and place with good light, as this is how Yoma Fleet will appraise the
                                    vehicle, so that we can get a good understanding of any problems.
                                </li>
                                <li>Wash the vehicle thoroughly before making it available for appraisal. </li>
                                <li>Check the upholstery for odours, tears, burns, stains and wear.</li>
                                <li>
                                    Inspect all controls, including audio equipment and accessories so that they are in
                                    fully working condition. Thoroughly clean and valet the interior.
                                </li>
                            </ul>
                        </Panel>
                    </Collapse>
                </Col>
            </Row>
        </div>
    );
};

export default FairwareAndTearPolicy;
